import { render, staticRenderFns } from "./client-page.vue?vue&type=template&id=25054a82&scoped=true&"
import script from "./client-page.vue?vue&type=script&lang=js&"
export * from "./client-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25054a82",
  null
  
)

export default component.exports